<template>
  <ion-app>

    <!-- ..class='sidebar' -->
    <!-- <sideBar class='sidebar'>
      <h5 slot="title">What is Lorem Ipsum?</h5>
      
      <h3 slot="body"> What is Lorem Ipsum? Lorem Ipsum is simply 
                       dummy text of the printing
                       andtypesetting industry.Lorem Ipsum has been 
                       the industry's standard dummy.
      </h3>
    
    </sideBar>-->

    <!-- <ion-button @click="menuOpen" size="default" class='topLeft circular'>
      <ion-icon slot="icon-only"  name="menu"></ion-icon>
    </ion-button>-->

    <ion-button @click="informationPage" size="large" Fill="clear" class="topRight">
      <!-- <ion-icon ios="ios-planet" md="md-planet" ></ion-icon> -->
      <ion-img :src="iconUrlInfo"></ion-img>
    </ion-button>

    <ion-button
      v-show="showControls"
      @click="toggleMapStyle"
      size="large"
      Fill="clear"
      class="bottomLeft"
    >
      <!-- <ion-icon ios="ios-map" md="md-map"></ion-icon> -->
      <!-- <ion-icon ios="ios-map" md="md-map"></ion-icon> -->
      <ion-img :src="iconUrlMapStyle"></ion-img>
      <!-- <ion-img  src=''></ion-img> -->
    </ion-button>

    <ion-button
      v-show="showControls"
      @click="toggleCampus"
      size="large"
      Fill="clear"
      class="bottomRight"
    >
      <!-- <ion-icon ios="ios-map" md="md-map"></ion-icon> -->
      <!-- <ion-icon name="settings"></ion-icon> -->
      <ion-img :src="iconUrlCampus"></ion-img>
    </ion-button>
    
   <!-- <ion-button class="topCenter" 
                Fill="outline"
                size="small"
                shape="round"
                
                
    >
       <ion-icon :src="iconCenterbutton"></ion-icon>
    </ion-button> -->
   
    <!-- <radialMenu class='bottomCenter'/> -->

    <ion-content>
      <keep-alive>
        <component :is="selectedMap"></component>
      </keep-alive>
      <surveillanceRender />
      <followTarget/>
    </ion-content>

    <notification/>
  </ion-app>
 
</template>

<script>
import { Plugins, CameraResultType, CameraSource } from "@capacitor/core";
const { App, Device, StatusBar, SplashScreen, Motion } = Plugins;
// import { DeviceOrientation, DeviceOrientationCompassHeading } from '@ionic-native/device-orientation/ngx';
import { DeviceEventBus } from "../DeviceEventBus.js";

import { version as appVersion } from "../../package.json";
import TwoDMap from "../components/maps/map";
import ThreeDMap from "../components/maps/3DMap";
import surveillanceRender from "../components/surveillance/surveillanceRender";
import followTarget from "../components/surveillance/followTarget"
import appInfo from "../components/AppInfo";

import sideBar from "../components/sideBar";
import radialMenu from "../components/radialMenu";
const uuidv4 = require("uuid/v4");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import notification from '../components/notification'
import {FollowTarget } from "../store/EventBus/FollowTargetEB"
export default {
  name: "home",
  data() {
    return {
      id: null,
      map: null,
      selectedMap: "TwoDMap",
      iconUrlCampus: require("../assets/campus-kdab25.svg"),
      iconUrlCampusKDAB: require("../assets/campus-kdab25.svg"),
      iconUrlCampusKPRC: require("../assets/campus-kprc25.svg"),
      iconUrlMapStyle: require("../assets/Mapswitchround5.svg"),
      iconUrlInfo: require("../assets/i-2_M4.svg"),
      iconCenterbutton :require('../assets/caret-down.svg'),
      displySurveillanceRender: false,
      campusLocation: {
        KDAB: {
          // coordinates: [-81.353, 29.3],
          coordinates: [-81.0580556, 29.1799167],
         // coordinates: [-81.50, 29],
          zoom: 10
        },
        KPRC: {
          coordinates: [-112.427153, 34.649904],
          zoom: 6.7
        }
      },
      selectedCampus: "KPRC",
      selectedMapIndex: 1,
      showControls: true
    };
  },
  components: {
    TwoDMap,
    surveillanceRender,
    ThreeDMap,
    sideBar,
    radialMenu,
    Loading,
    appInfo,
    followTarget,
    notification
  },
  beforeCreate() {},
  beforeMount() {
    console.log("Home beforeMount ");
  },
  async mounted() {
    this.id = uuidv4();
    // console.log("Home mounted ", this.id);
    // console.log(this.$helpers.getPlatform())

    this.map = this.$store.getters["mapStore/getMap"];
    this.selectedCampus = "KPRC";
    this.toggleCampus();

   // Wait till connection is active & request notification message
   let motdTimer =  setInterval(()=>{
       if( this.$store.state.connection.connected){ 
          this.$store.dispatch("motd/requestMotd", {});
          clearInterval(motdTimer)
       }
    }, 4000)
    

    // console.log(this.$helpers.deviceInfo())

    //  UploaderService.$on('progress', progress => {
    //     console.log('2 '+progress)
    //   });

    // UploaderService.orchestrateDataPublication().then(message => {
    //     console.log('1 '+message)
    //     UploaderService.$off('progress');
    //   })
    // console.log('version ',appVersion)
    // console.log(Capacitor.platform)

    // StatusBar.hide();
    // SplashScreen.hide()

    // this.info = await Device.getInfo();
    // console.log(this.info);

    // App.addListener('appStateChange', (state) => {
    //   // state.isActive contains the active state
    //   this.state = state
    //   console.log(this.state)
    //   console.log('App state changed. Is active?', state.isActive);
    // });

    // // Listen for serious plugin errors
    // App.addListener('pluginError', (info) => {
    //  console.error('There was a serious error with a plugin', err, info);
    // });
  },
  methods: {
    menuOpen(e) {
      console.log("menuOpen ");
    },
    toggleMapStyle() {
      // console.log("toggleMapStyle ..");
      if (this.selectedMapIndex === 6) {
        this.$store.dispatch("mapStore/setStyle", 1);
        this.selectedMapIndex = 1;
      } else {
        this.selectedMapIndex = 6;
        this.$store.dispatch("mapStore/setStyle", 6);
      }
    },
    toggleCampus() {
      
       FollowTarget.$emit("followTarget",{id:null})
      if (this.selectedCampus === "KDAB") {
        this.selectedCampus = "KPRC";
        // console.log(this.campusLocation["KPRC"])
        this.iconUrlCampus = this.iconUrlCampusKPRC;
        this.map.flyTo({
          center: this.campusLocation["KPRC"].coordinates,
          zoom: this.campusLocation["KPRC"].zoom,
          speed: 1.42,
          curve: 1
        });
        
      } else {
        this.selectedCampus = "KDAB";
        //  console.log(this.campusLocation["KDAB"])
        this.iconUrlCampus = this.iconUrlCampusKDAB;
        this.map.flyTo({
          center: this.campusLocation["KDAB"].coordinates,
          zoom: this.campusLocation["KDAB"].zoom,
          speed: 1.42,
          curve: 1
        });
        
      }
      //  console.log('toggleCampus ..',this.selectedCampus)
    },
    informationPage() {
      // console.log("informationPage ..");
      if (this.selectedMap === "TwoDMap") {
        this.selectedMap = "appInfo";
        this.showControls = false;
      } else {
        this.selectedMap = "TwoDMap";
        this.showControls = true;
        DeviceEventBus.windowOrientationHandler()
      }
      
    },
    reloadHandler(event) {
      this.$nextTick(() => {
        console.log("leaving", this.$router); // logs to my logger
        this.$store.dispatch("connection/disconnect");
        this.$router.push("/");
      });
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.reloadHandler);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.reloadHandler);
  }
};
</script>
<style scoped>
/* html,body {
  height: 100%;
} */

#mapBox {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
.topLeft {
  top: 1%;
  left: 1%;
  position: absolute;
  z-index: 999;
}
.topRight {
  top: 1%;
  right: 1%;
  position: absolute;
  z-index: 999;
  --background: transparent;
}
.circular {
  --width: 40%;
  --height: 40%;
  --border-radius: 50%;
  --vertical-align: middle;
  --padding-start: 5px;
  --padding-end: 5px;
  --border-style: ridge;
  --background: transparent;
  --color: rgb(84, 79, 79);
}
.bottomCenter {
  position: fixed;
  left: 50%;
  bottom: 1%;
  margin: 0 auto;
  z-index: 900;
  /* transform: translate(-50%, -50%); */
}
.topCenter {
  position: fixed;
  left: 50%;
  top: 1%;
  margin: 0 auto;
  z-index: 900;
  /* transform: translate(-50%, -50%); */
}
.bottomLeft {
  position: absolute;
  bottom: 1%;
  left: 0%;
  z-index: 900;
}
.bottomRight {
  position: absolute;
  bottom: 1%;
  right: 0%;
  z-index: 900;
}
.sidebar {
  top: 1%;
  left: 1%;
  position: absolute;
  z-index: 999;
}
</style>
